import { Skeleton } from '@/_components';

export function Loading() {
  return (
    <ul className="list-none">
      {Array.from({ length: 6 }).map((_, index) => (
        <li className="border-c-border-muted grid h-20 grid-cols-2 items-center gap-2 border-b py-2" key={index}>
          <section className="group flex shrink-0 grow-0 items-start gap-2">
            <Skeleton className="h-7 w-9 shrink-0 grow-0 rounded-md" />
            <div className="flex w-full flex-col gap-1">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </section>

          <section className="flex shrink-0 grow-0 basis-1/2 flex-col gap-1">
            <Skeleton className="h-4 w-3/4" />

            <div className="grid grid-cols-2 items-center">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-4 w-3/4" />
            </div>

            <Skeleton className="h-4 w-3/4" />
          </section>
        </li>
      ))}
    </ul>
  );
}
